import { ReactNode } from 'react'

// Items are separated by one gap and one divider, owned here so no setting needs its own margins.
export function SettingsGroup({ children }: { children: ReactNode }) {
	return (
		<div className='flex flex-col gap-6 [&>*+*]:border-t [&>*+*]:border-charcoal-400 [&>*+*]:pt-6'>
			{children}
		</div>
	)
}

type SettingsItemProps = {
	title: string
	// Secondary text: explains the setting. State and warnings belong in an InlineAlert child instead.
	description?: ReactNode
	children?: ReactNode
	'data-testid'?: string
}

// Titles sit flush with the accordion heading; everything beneath is indented one step. No bold: hierarchy is by indent.
export function SettingsItem({ title, description, children, ...rest }: SettingsItemProps) {
	return (
		<div data-testid={rest['data-testid']}>
			<h3 className='text-white'>{title}</h3>
			{(description || children) && (
				<div className='pl-6'>
					{description && <div className='mt-1 text-charcoal-100'>{description}</div>}
					{children && <div className='mt-3 space-y-3'>{children}</div>}
				</div>
			)}
		</div>
	)
}

export function SettingsSubItem({ title, children }: { title: string; children: ReactNode }) {
	return (
		<div>
			<h4 className='text-white'>{title}</h4>
			<div className='mt-3 pl-6'>{children}</div>
		</div>
	)
}
